import React from 'react'

interface EmailHighlightProps {
  text: string
}

const EmailHighlight: React.FC<EmailHighlightProps> = ({ text }) => {
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/g

  const parts = text.split(emailRegex)

  return (
    <p>
      {parts.map((part, index) =>
        emailRegex.test(part) ? (
          <a
            key={index}
            href={`mailto:${part}`}
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            {part}
          </a>
        ) : (
          part
        )
      )}
    </p>
  )
}

export default EmailHighlight
